import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Stack, Chip, Divider, List, ListItem, ListItemText
} from '@mui/material';

type Props = {
  open: boolean;
  template: any | null;
  applying?: boolean;
  onClose: () => void;
  onApply: (templateCode: string) => void;
};

class TemplateDetailsDialog extends React.Component<Props> {
  render() {
    const { open, template, applying, onClose, onApply } = this.props;

    if (!template) return null;

    const tasks = template.tasks || template.tasklist || [];
    const budgetLines = template.budgetlines || template.budgetLines || [];

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>{template.name || template.recname || template.code}</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              {template.description || 'This template will create a standard planning structure for the selected activity.'}
            </Typography>

            <Stack direction="row" spacing={1}>
              <Chip label={`${tasks.length} Tasks`} size="small" />
              <Chip label={`${budgetLines.length} Budget Lines`} size="small" />
            </Stack>

            <Divider />

            {/* {
              "edt": "",
              "nam": "Sélection du prestataire",
              "own": "Responsable formation",
              "sdt": "",
              "sts": "DRAFT",
              "tsk": "PROVIDER",
              "wgt": 25.00
            }, */}

            <Typography variant="subtitle2">Tasks to be created</Typography>
            <List dense>
              {tasks.length === 0 ? (
                <ListItem><ListItemText primary="No task details available." /></ListItem>
              ) : tasks.map((x: any, i: number) => (
                <ListItem key={i}>
                  <ListItemText
                    primary={`${i + 1}. ${x.nam || x.name || x.recname || x.taskname || x.code}`}
                    //secondary={x.description || x.dsc || ''}
                    secondary={`${x.tsk || x.task || ''}, ${x.sts || x.status || ''} `}
                  />
                </ListItem>
              ))}
            </List>

            <Divider />

             {/* {
              "acc": null,
              "amt": 0,
              "dsc": "Commission / comité",
              "qty": 1,
              "rmk": "Frais commission",
              "ttc": "EVAL",
              "upr": 0
            }, */}

            <Typography variant="subtitle2">Budget lines to be created</Typography>
            <List dense>
              {budgetLines.length === 0 ? (
                <ListItem><ListItemText primary="No budget line details available." /></ListItem>
              ) : budgetLines.map((x: any, i: number) => (
                <ListItem key={i}>
                  <ListItemText
                    // primary={`${i + 1}. ${x.name || x.recname || x.description || x.accountcode}`}
                    // secondary={x.amount ? `Estimated amount: ${x.amount}` : ''}
                    primary={`${i + 1}. ${x.dsc || x.recname || x.description || x.accountcode}`}
                    secondary={Number.isFinite(x.amt) ? `Estimated amount: ${x.amt}` : ''}
                  />
                </ListItem>
              ))}
            </List>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            disabled={applying}
            onClick={() => onApply(template.code || template.shortcode || template.shc)}
          >
            Apply Template
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default TemplateDetailsDialog;